import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { Subscription } from "rxjs";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { SaldoResumen } from "src/app/models/Saldo/SaldoResumen";
import { SaldoSeleccion } from "src/app/models/Saldo/SaldoSeleccion";
import { SaldoService } from "src/app/services/saldo.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { SaldoFavorCalculo } from "./saldo-favor-calculo";

@Component({
	selector: "app-saldo-favor-bloque",
	templateUrl: "./saldo-favor-bloque.component.html",
	styleUrls: ["./saldo-favor-bloque.component.scss"],
})
export class SaldoFavorBloqueComponent implements OnInit, OnChanges, OnDestroy {
	@Input() public total = 0;
	@Input() public maximoElegible: number = null;
	@Input() public planUsuario: PlanUsuario;
	@Input() public permitirTitularSinPlan = false;
	@Input() public disabled = false;
	@Output() public seleccionChange = new EventEmitter<SaldoSeleccion>();

	public resumen: SaldoResumen = {
		tieneCuenta: false,
		saldoContable: 0,
		saldoReservado: 0,
		saldoDisponible: 0,
		moneda: "CLP",
	};
	public usarSaldoFavor = false;
	public cargando = false;
	public errorConsulta = false;
	public puedeUsarSaldo = false;
	private refrescarSub: Subscription;

	constructor(
		private saldoService: SaldoService,
		private tokenStorage: TokenStorageService
	) {}

	public ngOnInit(): void {
		this.evaluarTitular();
		if (this.puedeUsarSaldo) this.cargarSaldo();
		this.refrescarSub = this.saldoService.refrescar$.subscribe(() => {
			this.usarSaldoFavor = false;
			this.emitirSeleccion();
			if (this.puedeUsarSaldo) this.cargarSaldo();
		});
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes["planUsuario"] || changes["permitirTitularSinPlan"]) {
			this.evaluarTitular();
		}
		if (changes["total"] || changes["maximoElegible"] || changes["disabled"]) {
			this.actualizarUsoObligatorio();
			this.emitirSeleccion();
		}
	}

	public ngOnDestroy(): void {
		if (this.refrescarSub) this.refrescarSub.unsubscribe();
	}

	public get maximoAplicable(): number {
		const elegible = this.maximoElegible == null ? this.total : this.maximoElegible;
		return SaldoFavorCalculo.maximoAplicable(this.resumen.saldoDisponible, elegible);
	}

	public get saldoAplicadoEsperado(): number {
		return this.usarSaldoFavor ? this.maximoAplicable : 0;
	}

	public get diferenciaPago(): number {
		return SaldoFavorCalculo.diferenciaPago(this.total, this.saldoAplicadoEsperado);
	}

	private evaluarTitular(): void {
		const usuarioId = String(this.tokenStorage.getUser()?.id ?? "").toLowerCase();
		const usuarioBaseId = String(this.planUsuario?.usuarioId ?? "").toLowerCase();
		this.puedeUsarSaldo = Boolean(usuarioId) && (
			(Boolean(usuarioBaseId) && usuarioId === usuarioBaseId) ||
			(this.permitirTitularSinPlan && !usuarioBaseId)
		);
		this.actualizarUsoObligatorio();
	}

	private cargarSaldo(): void {
		this.cargando = true;
		this.errorConsulta = false;
		this.saldoService.obtenerResumen().subscribe({
			next: (resumen) => {
				this.resumen = resumen;
				this.cargando = false;
				this.actualizarUsoObligatorio();
				this.emitirSeleccion();
			},
			error: () => {
				this.cargando = false;
				this.errorConsulta = true;
				this.usarSaldoFavor = false;
				this.emitirSeleccion();
			},
		});
	}

	private actualizarUsoObligatorio(): void {
		this.usarSaldoFavor = this.puedeUsarSaldo
			&& !this.disabled
			&& !this.cargando
			&& !this.errorConsulta
			&& this.maximoAplicable > 0;
	}

	private emitirSeleccion(): void {
		this.seleccionChange.emit({
			usarSaldoFavor: this.usarSaldoFavor,
			saldoAplicadoEsperado: this.saldoAplicadoEsperado,
		});
	}
}
